import axios from "axios";

const backendBaseUrl = process.env.REACT_APP_BACKEND_URL;
const requestConfig = {
  timeout: 10000,
};

export async function login(email, password) {
  const reqUrl = `${backendBaseUrl}/auth/login`;
  const reqPayload = {
    email: email,
    password: password,
  };
  return await axios
    .post(reqUrl, reqPayload, requestConfig)
    .then((response) => {
      console.log(response.data);
      localStorage.setItem("jwToken", JSON.stringify(response.data.jwToken));
      localStorage.setItem("userId", response.data.userId);

      console.log(response.data);
      return response.data;
    })
    .catch((error) => {
      alert(
        error?.response?.data?.error ||
          error?.response?.data?.message ||
          "Unable to log in right now."
      );
      throw error;
    });
}

export async function register(name, email, password, confirmPassword) {
  const reqUrl = `${backendBaseUrl}/auth/register`;
  const reqPayload = {
    name: name,
    email: email,
    password: password,
    confirmPassword: confirmPassword,
  };

  return await axios
    .post(reqUrl, reqPayload, requestConfig)
    .then((response) => {
      localStorage.setItem("jwToken", JSON.stringify(response.data.jwToken));
      localStorage.setItem("userId", response.data.userId);
      console.log(response.data);
      return response.data;
    })
    .catch((error) => {
      alert(
        error?.response?.data?.error ||
          error?.response?.data?.message ||
          "Unable to sign up right now."
      );
      throw error;
    });
}
